import { defineSlotRecipe } from '@chakra-ui/react';

import {
  tabsCyberVariant,
  tabsFilterVariant,
  tabsLightVariant,
  tabsNeutralVariant,
  tabsVerticalVariant,
} from '../variants/tabs';

export const tabsSlotRecipe = defineSlotRecipe({
  className: 'chakra-tabs',
  slots: ['root', 'content', 'indicator', 'list', 'trigger', 'contentGroup'],
  base: {
    root: {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      flex: 1,
      '&[data-orientation=horizontal]': {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
      },
      '&[data-orientation=vertical]': {
        display: 'flex',
        flexDirection: 'row',
        overflowX: 'auto',
      },
    },
    list: {
      '&[data-orientation=horizontal]': {
        width: '100%',
        justifyContent: 'center',
      },
      '&[data-orientation=vertical]': {
        height: '100%',
      },
      cursor: 'default',
      border: 'none',
      flexShrink: 0,
    },
    trigger: {
      justifyContent: 'center',
      paddingLeft: 2,
      paddingRight: 2,
      paddingY: 0,
      width: 'fit-content',
      minWidth: 'fit-content',
      height: '56px',
      '&[data-orientation=vertical]': {
        width: '100%',
        height: '66px',
        flexShrink: 0,
      },
      flexGrow: 1,
      lineClamp: 1,
      outline: 'none !important',
      fontWeight: 'regular',
      _selected: {
        borderColor: 'blue.500',
        fontWeight: 'medium',
      },
      _hover: {
        cursor: 'pointer',
        _selected: {
          borderColor: 'blue.500',
          cursor: 'default',
        },
      },
      _disabled: {
        borderColor: 'blue.700',
        cursor: 'default',
        _hover: {
          backgroundColor: 'neutral.850',
          borderColor: 'blue.700',
          cursor: 'default',
          _selected: {
            cursor: 'default',
          },
        },
      },
    },
    contentGroup: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 !important',
      flex: 1,
      overflow: 'hidden',
      backgroundColor: 'transparent',
      minHeight: 0,
    },
    content: {
      padding: '0 !important',
      backgroundColor: 'transparent',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },
  },
  variants: {
    variant: {
      cyber: tabsCyberVariant,
      filter: tabsFilterVariant,
      neutral: tabsNeutralVariant,
      light: tabsLightVariant,
      vertical: tabsVerticalVariant,
    },
    size: {
      sm: {
        trigger: {
          textStyle: 'sm',
        },
      },
      md: {
        trigger: {
          textStyle: 'md',
        },
      },
      lg: {
        trigger: {
          textStyle: 'lg',
        },
      },
      screenStd: {
        trigger: {
          textStyle: 'screenStd',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'cyber',
    size: 'sm',
  },
});
